import React, { useRef, useEffect, useState } from 'react';
import axios from "axios";
import { useParams, useHistory } from "react-router-dom";
import WebViewer from '@pdftron/pdfjs-express-viewer';
import { base_url, base_url_completa } from '../../constants';
import { Modal, Button } from 'react-bootstrap';
import { webApiObra } from "../../routes/endpoints";
import { webApiLicencia } from "../../routes/endpoints";
import ReferenciaBibliografica from "../PDFViewer/ReferenciaBibliografica";
import  {ventana}  from '../../utilities/Alertas';

const PdfViewer = () => {
    const { id } = useParams();
    const [obra, setObra] = useState(null);
    const [pagina, setPagina] = useState(1);
    let history = useHistory();
    //Para setear y renderizar el cambio de página
    useEffect(() => {}, [pagina]);
    //Obtenemos la información de la licencia dependiendo
    useEffect(() => {
        //enviar parámetro tipo dependiendo la url
        //1 local 2 desarrollo 3 producción
        let idAmbiente;
        //console.log(base_url);
        if(/^(http|https):\/\/localhost/.test(base_url_completa)){
            idAmbiente = 1;
        }
        if(/^(http|https):\/\/10.10.106.26/.test(base_url_completa)){
            idAmbiente = 2;
        }
        if(/^(http|https):\/\/www.te.gob.mx/.test(base_url_completa)){
            idAmbiente = 3;
        }
        if(/^(http|https):\/\/10.10.106.179/.test(base_url_completa)){
            idAmbiente = 4;
        }
        const requestObra = axios.post(webApiObra, { id: id }); 
        const requestLicencia = axios.post(webApiLicencia, { id: idAmbiente });
        axios.all([requestObra, requestLicencia]).then(axios.spread((...responses) => {
            setObra(responses[0].data)
            setTimeout(() =>{
                if(responses[0].data[0].archivo === null){
                    ventana('No se encontro el archivo','El documento no se encuentra disponible para lectura en línea', 'error')
                }else{
                    if(responses[0].data[0].archivo !== undefined && responses[1].data[0].licencia !== undefined) {                
                            WebViewer(
                                {
                                    path: 'webviewer/lib',
                                    initialDoc: '../files/' + responses[0].data[0].archivo,
                                    licenseKey: responses[1].data[0].licencia,
                                    disabledElements: [
                                        'viewControlsButton',
                                        'menuButton',
                                        'contextMenuPopup'
                                    ]
                                },
                                viewer.current,
                            ).then((instance) => {
                                const { Core, UI } = instance;
                                UI.setLanguage('es');
                                Core.documentViewer.disableAnnotations();
                                instance.UI.enableElements([ 'bookmarksPanelButton' ]);
                                Core.documentViewer.addEventListener('pageNumberUpdated', (pageNumber) => {
                                    //console.log(`La página es: ${pageNumber}`);
                                    setPagina(pageNumber);
                                });
                                UI.setHeaderItems(header => {
                                    header.push({
                                        type: 'actionButton',
                                        img: `/${base_url}/webviewer/icons/box-arrow-in-up-right.svg`,
                                        title:'Referencia bibliográfica',
                                        onClick: () => {
                                            //console.log(document.querySelector('#vistaModal'));
                                            setModalShow(true);
                                        }
                                    });
                                });
                                UI.setHeaderItems(header => {
                                    header.push({
                                        type: 'actionButton',
                                        img: `/${base_url}/webviewer/icons/chevron-double-left.svg`,
                                        title:'Primera página',
                                        onClick: () => {
                                            Core.documentViewer.setCurrentPage(1);
                                        }
                                    });
                                });
                                UI.setHeaderItems(header => {
                                    header.push({
                                        type: 'actionButton',
                                        img: `/${base_url}/webviewer/icons/chevron-left.svg`,
                                        title:'Página anterior',
                                        onClick: () => {
                                            const currentPage = Core.documentViewer.getCurrentPage();
                                            const totalPages = Core.documentViewer.getPageCount();
                                            const atFirstPage = currentPage === 1;
                    
                                            if (atFirstPage) {
                                                Core.documentViewer.setCurrentPage(totalPages);
                                            } else {
                                                Core.documentViewer.setCurrentPage(currentPage - 1);
                                            }
                                        }
                                    });
                                });
                                UI.setHeaderItems(header => {
                                    header.push({
                                        type: 'actionButton',
                                        img: `/${base_url}/webviewer/icons/chevron-right.svg`,
                                        title:'Página siguiente',
                                        onClick: () => {
                                            const currentPage = Core.documentViewer.getCurrentPage();
                                            const totalPages = Core.documentViewer.getPageCount();
                                            const atLastPage = currentPage === totalPages;
                    
                                            if (atLastPage) {
                                                Core.documentViewer.setCurrentPage(1);
                                            } else {
                                                Core.documentViewer.setCurrentPage(currentPage + 1);
                                            }
                                        }
                                    });
                                });
                                UI.setHeaderItems(header => {
                                    header.push({
                                        type: 'actionButton',
                                        img: `/${base_url}/webviewer/icons/chevron-double-right.svg`,
                                        title:'Última página',
                                        onClick: () => {
                                            Core.documentViewer.setCurrentPage(Core.documentViewer.getPageCount());
                                        }
                                    });
                                });
                                UI.setHeaderItems(header => {
                                    header.push({
                                        type: 'actionButton',
                                        img: `/${base_url}/webviewer/icons/arrows-fullscreen.svg`,
                                        title:'Pantalla completa',
                                        onClick: () => {
                                            UI.toggleFullScreen();
                                        }
                                    });
                                });
                                UI.setHeaderItems(header => {
                                    header.push({
                                        type: 'actionButton',
                                        img: `/${base_url}/webviewer/icons/back-arrow.svg`,
                                        title: 'Regresar',                        
                                        onClick: () => {
                                            history.goBack()
                                        }
                                    });
                                });
                                //Para ocultar las opciones en la búsqueda
                                const iframeWindow = instance.UI.iframeWindow;
                                iframeWindow.document.querySelector('.options').setAttribute('style', 'display: none');
                            });
                    }
                }
            },500)
        })).catch(err => console.warn(err))
    }, []);
    function MyVerticallyCenteredModal(props) {
        return (
            <Modal
                {...props}
                size="xl"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                className="pt-5 mt-5"
            >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter" className='text-success'>
                        <h1>Referencia bibliográfica</h1>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <ReferenciaBibliografica id='referencia' paginaActual={pagina} {...props} {...obra[0]} />
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={props.onHide}>Cerrar</Button>
                </Modal.Footer>
            </Modal>
        );
    }

    const viewer = useRef(null);
    const [modalShow, setModalShow] = React.useState(false);
    if (obra !== null) {
        return (
            <>
                <div id="App" className="webviewer" ref={viewer}><p/></div>
                <div id="vistaModal">
                    <MyVerticallyCenteredModal
                        show={modalShow}
                        onHide={() => setModalShow(false)} 
                    />
                </div>
            </>
        );
    } else {
        return (<></>)
    }

};

export default PdfViewer;